

import {  useState } from "react";
import '../pages/SettingPageuser.css'
import './EditModalDam.css'
import { useGlobalContext } from "./Context";
import { useDispatch, useSelector } from "react-redux";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import LoadingCop from "./Loading";
import { useNavigate } from "react-router-dom";

import apiService from "../api/ApiService";
import { Close } from "@mui/icons-material";
const moment=require('moment-jalaali');


const DeleteFarms=()=>{
    const {currentSfarm}=useSelector(state=>state.p.sFarm)
   
    const {openDeleteModal,closedeleteModal,isDeleteModalOpen}=useGlobalContext();
   
    const navigate=useNavigate()
   

    const deleteFarm=async()=>{           
                
                const res=await apiService.deleteFarm(currentSfarm.id);
                
                openDeleteModal();navigate('/AllFarmsAdmin')
               
    }
    

    return <div onClick={closedeleteModal} className={`modal-overlay ${isDeleteModalOpen&&'show-modal'} `}>
        <div className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>
            <div className="editModalDamConHead">
            <PriorityHighIcon fontSize='large'/>

            <h4 >آیا از حذف این دامداری مطمئن هستید؟</h4>
            </div>
       
        
        <button className="EditMOdalBtnForm" onClick={deleteFarm}>
            تایید
        </button>
        
        </div>
        <div style={{marginTop:'120px'}}> 
        
        </div>
        
    </div>
}
export default DeleteFarms